import { useReducer } from 'react'

// `business_name` lives on the Order model as a jsonb_accessor :data
// string attribute (see app/models/order.rb), so saveDraft just needs
// to include `business_name: 'Acme Inc.'` (or `''` to clear) in the
// order body — no nested attributes plumbing required.
//
// The `enabled` arg gates the whole hook on the partner-config
// `collect_business_name` flag. When the partner hasn't enabled the
// field, draftOrderProps returns {} so we don't accidentally clear an
// existing business_name on a returning donor's draft. When the
// partner *has* enabled it, draftOrderProps returns either the typed
// value (donor opted in) or an empty string (donor unticked the
// modal), with the empty-string path explicitly clearing whatever
// the order may have previously held.
//
// Holds the donor's committed selection only — CompanyContribution.jsx
// owns the live editing copy and calls setState here when the donor
// saves.

const reducer = (state, action) => {
  switch (action.type) {
  case 'setState':
    return action.value
  default:
    throw new Error('Invalid reducer action')
  }
}

const useCompanyContribution = ({ order, enabled = true }) => {
  const [ state, dispatch ] = useReducer(reducer, {
    optedIn: !!order.business_name,
    businessName: order.business_name || '',
  })

  const setState = value => dispatch({ type: 'setState', value })

  const draftOrderProps = () => {
    if (!enabled) return {}
    return state.optedIn
      ? { business_name: state.businessName }
      : { business_name: '' }
  }

  return { enabled, state, setState, draftOrderProps }
}

export default useCompanyContribution
